<template>
  <div class="videoGroup" v-if="showGroup">
    <div v-if="showGroupName" class="videoGroupName">{{name}}</div>
    <div class="videoGrid">
      <VideoItem v-for="video in videoList" :key="video.id" :video="video"/>
    </div>
  </div>
</template>

<script>
import VideoItem from '../components/VideoItem.vue'

export default {
  name: 'VideoGroup',
  components: {
    VideoItem
  },
  props: {
    videoList: Array,
    directions: Object,
    name: String,
    showGroupName: Boolean
  },
  computed: {
    showGroup() {
      var videosWithAssets = this.videoList.filter((video)=>{
        return video.asset ? true : false
      })
      return videosWithAssets.length > 0 ? true : false
    }
  }
}
</script>

<style scoped>
  .videoGroup {
    width: 100%;
  }
  .videoGroupName {
    padding: 20px 0px 0px 20px;
  }
  .videoGrid{
    width: 100%;
    padding: 10px;
    display: grid;
    grid-template-columns: repeat(auto-fill, 300px);
    grid-gap: 10px;
    overflow-y:scroll;
    justify-content: space-evenly;
  }
</style>
